// Enum for relationship types matching backend
export enum RelationshipType {
  SELF = 0,
  FATHER = 1,
  SON = 2,
  MOTHER = 3,
  DAUGHTER = 4,
  SIBLING = 5,
  PET = 6,
  OTHER = 7,
  SPOUSE = 8,
  BROTHER = 9,
  SISTER = 10,
}

export const relationshipOptions = [
  { label: 'Self', value: RelationshipType.SELF },
  { label: 'Spouse', value: RelationshipType.SPOUSE },
  { label: 'Father', value: RelationshipType.FATHER },
  { label: 'Mother', value: RelationshipType.MOTHER },
  { label: 'Son', value: RelationshipType.SON },
  { label: 'Daughter', value: RelationshipType.DAUGHTER },
  { label: 'Sibling', value: RelationshipType.SIBLING },
  { label: 'Pet', value: RelationshipType.PET },
  { label: 'Other', value: RelationshipType.OTHER },
];

export const relationshipOptionsForAddMember = [
  { label: 'Spouse', value: RelationshipType.SPOUSE },
  { label: 'Daughter', value: RelationshipType.DAUGHTER },
  { label: 'Son', value: RelationshipType.SON },
  { label: 'Mother', value: RelationshipType.MOTHER },
  { label: 'Father', value: RelationshipType.FATHER },
  { label: 'Brother', value: RelationshipType.BROTHER },
  { label: 'Sister', value: RelationshipType.SISTER },
  { label: 'Pet', value: RelationshipType.PET },
  { label: 'Other', value: RelationshipType.OTHER },
];

export const relationshipOptionsForEmergency = [
  { label: 'Spouse', value: RelationshipType.SPOUSE },
  { label: 'Daughter', value: RelationshipType.DAUGHTER },
  { label: 'Son', value: RelationshipType.SON },
  { label: 'Mother', value: RelationshipType.MOTHER },
  { label: 'Father', value: RelationshipType.FATHER },
  { label: 'Brother', value: RelationshipType.BROTHER },
  { label: 'Sister', value: RelationshipType.SISTER },
  { label: 'Other', value: RelationshipType.OTHER },
];